/**
 * Accordion module
 * Handles the accordion functionality for FAQ sections using <details> and <summary> elements.
 * Ensures only one accordion item is open at a time and provides smooth animations for opening and closing.
 * Also manages ARIA attributes for accessibility.
 * @see src/template-parts/blocks/faqs/template.php
 */

export default class Accordion {
  constructor(i) {
    (this.el = i),
    (this.summary = i.querySelector("summary")),
    (this.content = i.querySelector(".accordion-body")),
    (this.animation = null),
    (this.isClosing = !1),
    (this.isExpanding = !1),
    this.summary.addEventListener("click", (i) => this.onClick(i));
    // Add a static property to track all instances
    if (!Accordion.instances) {
      Accordion.instances = [];
    }
    Accordion.instances.push(this);
  }

  // Add method to close other accordions
  closeOthers() {
    Accordion.instances.forEach(accordion => {
      if (accordion !== this && accordion.el.open) {
        accordion.shrink();
      }
    });
  }

  onClick(i) {
    i.preventDefault();
    // Disable toggle when commute accordion is in "expanded desktop" mode (≥992px)
    if (this.el.closest(".commute-options.accordion") && window.matchMedia("(min-width: 992px)").matches) {
      return;
    }
    this.el.style.overflow = "hidden";
    if (this.isClosing || !this.el.open) {
      // Close other accordions before opening this one
      this.closeOthers();
      this.open();
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }
  }
  shrink() {
    this.isClosing = !0;
    this.summary.classList.add('collapsed');
    let i = `${this.el.offsetHeight}px`,
      t = `${this.summary.offsetHeight}px`;
    this.animation && this.animation.cancel(),
      (this.animation = this.el.animate(
        { height: [i, t] },
        { duration: 400, easing: "ease-in-out" }
      )),
      (this.animation.onfinish = () => this.onAnimationFinish(!1)),
      (this.animation.oncancel = () => (this.isClosing = !1));
  }
  open() {
    (this.el.style.height = `${this.el.offsetHeight}px`),
      (this.el.open = !0),
      window.requestAnimationFrame(() => this.expand());
  }
  expand() {
    this.isExpanding = !0;
    this.summary.classList.remove('collapsed');
    let i = `${this.el.offsetHeight}px`,
      t = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
    this.animation && this.animation.cancel(),
      (this.animation = this.el.animate(
        { height: [i, t] },
        { duration: 400, easing: "ease-out" }
      )),
      (this.animation.onfinish = () => this.onAnimationFinish(!0)),
      (this.animation.oncancel = () => (this.isExpanding = !1));
  }
  onAnimationFinish(i) {
    (this.el.open = i),
    (this.animation = null),
    (this.isClosing = !1),
    (this.isExpanding = !1),
    (this.el.style.height = this.el.style.overflow = "");
    // Set the aria-expanded attribute based on whether the details is open or closed
    this.summary.setAttribute('aria-expanded', i);
    if(this.el.open) {
      this.summary.classList.remove('collapsed');
    }
    else {
      this.summary.classList.add('collapsed');
    }
  }
}
